/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_CrumbInputs */

const th_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าแรก`)
};

const en_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const ja_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム`)
};

const zh_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

const es_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const pt_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const id_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beranda`)
};

const fr_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accueil`)
};

const tl_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simula`)
};

const vi_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ`)
};

const ko_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈`)
};

const de_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const ru_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главная`)
};

const tr_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana sayfa`)
};

const it_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const pl_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const uk_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Головна`)
};

const hi_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य`)
};

const ar_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرئيسية`)
};

const ms_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utama`)
};

const bn_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হোম`)
};

const zh_tw2_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首頁`)
};

const zh_hk2_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首頁`)
};

const ur_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہوم`)
};

const fa_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خانه`)
};

const sw_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwanzo`)
};

const nl_home_crumb = /** @type {(inputs: Home_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Home_CrumbInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_crumb = /** @type {((inputs?: Home_CrumbInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_CrumbInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_crumb(inputs)
	if (locale === "ja") return ja_home_crumb(inputs)
	if (locale === "zh") return zh_home_crumb(inputs)
	if (locale === "es") return es_home_crumb(inputs)
	if (locale === "pt") return pt_home_crumb(inputs)
	if (locale === "id") return id_home_crumb(inputs)
	if (locale === "fr") return fr_home_crumb(inputs)
	if (locale === "tl") return tl_home_crumb(inputs)
	if (locale === "vi") return vi_home_crumb(inputs)
	if (locale === "ko") return ko_home_crumb(inputs)
	if (locale === "de") return de_home_crumb(inputs)
	if (locale === "ru") return ru_home_crumb(inputs)
	if (locale === "tr") return tr_home_crumb(inputs)
	if (locale === "it") return it_home_crumb(inputs)
	if (locale === "pl") return pl_home_crumb(inputs)
	if (locale === "uk") return uk_home_crumb(inputs)
	if (locale === "hi") return hi_home_crumb(inputs)
	if (locale === "ar") return ar_home_crumb(inputs)
	if (locale === "ms") return ms_home_crumb(inputs)
	if (locale === "bn") return bn_home_crumb(inputs)
	if (locale === "zh-TW") return zh_tw2_home_crumb(inputs)
	if (locale === "zh-HK") return zh_hk2_home_crumb(inputs)
	if (locale === "ur") return ur_home_crumb(inputs)
	if (locale === "fa") return fa_home_crumb(inputs)
	if (locale === "sw") return sw_home_crumb(inputs)
	if (locale === "nl") return nl_home_crumb(inputs)
	return en_home_crumb(inputs)
});